import { sendGAEvent } from '@next/third-parties/google';
import dayjs from 'dayjs';
import { useState, useEffect } from 'react'

export default function useAlarm(stationId: string) {
    const [selectedTime, setSelectedTime] = useState<{ hour: number; minute: number } | null>(null)
    const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null)

    const cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        setSelectedTime(null)
        setTimeoutId(null)
    }

    const set = (hour: number, minute: number) => {
        const now = dayjs()
        const alarmTime = dayjs().hour(hour).minute(minute).second(0)
        if (alarmTime.isBefore(now))
            alarmTime.add(1, 'day')

        const timeUntilAlarm = alarmTime.diff(now)
        const timeout = setTimeout(playAudio, timeUntilAlarm)
        setSelectedTime({ hour, minute })
        setTimeoutId(timeout)
        sendGAEvent('event', 'alarm', { screen_name: stationId, value: `${hour}:${minute}` })
    }

    const playAudio = () => {
        const audioElement = document.querySelector('audio')
        if (audioElement) {
            audioElement.currentTime = 0
            audioElement.load()
            audioElement.play()
        }
    }

    useEffect(() => {
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId)
            }
        }
    }, [timeoutId])

    return {
        set, 
        timer: selectedTime,
        cancel
    }
}
